// extracted by mini-css-extract-plugin
module.exports = {"form":"Search_form__7Bw8E","inp":"Search_inp__3GPUR","icon":"Search_icon__1mjTD"};